module.exports = __webpack_public_path__ + "static/media/grin-squint.2ec62cf9.svg";